<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>广告管理</el-breadcrumb-item>
        <el-breadcrumb-item>轮播图管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container">
      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="800" border>
          <el-table-column align="center" type="selection" width="55"> </el-table-column>

          <el-table-column prop="adId" align="center" label="id"> </el-table-column>

          <el-table-column prop="title" align="center" label="标题"> </el-table-column>

          <el-table-column prop="imgUrl" align="center" label="缩略图">
            <template slot-scope="scope">
              <div class="table-thumbnail">
                <img :src="scope.row.imgUrl" alt="" />
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="redirectUrl" align="center" label="跳转地址"> </el-table-column>

          <el-table-column prop="sort" align="center" label="跳转地址"> </el-table-column>

          <el-table-column prop="status" align="center" label="激活状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">未激活</span>
              <span v-else>已激活</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <confirm-button v-if="scope.row.status === 0" type="text" title="确认要激活该条广告 ？" @confirmed="activeItem(scope.row.adId)">
                <span>激活</span>
              </confirm-button>
              <confirm-button v-if="scope.row.status === 1" type="text" title="确认要禁用该条广告 ？" @confirmed="forbidItem(scope.row.adId)">
                <span>禁用</span>
              </confirm-button>
              <el-button type="text" @click="editItem(scope.row)">修改</el-button>
              <confirm-button type="text" title="确认要删除该条广告 ？" @confirmed="deleteItem(scope.row.adId)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <el-form :model="itemParams" :rules="checkItemParams" ref="dialogForm" label-width="100px">
        <el-form-item label="标题：" prop="title">
          <el-input v-model="itemParams.title" size="small" placeholder="请输入标题"> </el-input>
        </el-form-item>

        <el-form-item label="缩率图：" prop="imgUrl">
          <div class="thumbnail-img">
            <i class="el-icon-circle-plus-outline upload-icon"></i>
            <input type="file" class="hidden-upload" @change="doUpload" id="uploadDom" />
            <img :src="itemParams.imgUrl" alt="" class="thumbnail-img-wrapped" />
          </div>
        </el-form-item>

        <el-form-item label="排序：" prop="sort">
          <el-input-number v-model="itemParams.sort" :min="1"> </el-input-number>
        </el-form-item>

        <el-form-item label="是否激活：" prop="status">
          <el-radio v-model="itemParams.status" :label="1">是</el-radio>
          <el-radio v-model="itemParams.status" :label="0">否</el-radio>
        </el-form-item>

        <el-form-item label="跳转地址：" prop="redirectUrl">
          <el-input v-model="itemParams.redirectUrl" size="small" placeholder="请输入跳转地址">
            <template slot="prepend">http://</template>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button :disabled="isDisabled" size="small" type="primary" @click="saveItem('dialogForm')"> 保 存 </el-button>

          <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    const checkIsImgUrl = function (rule, value, callback) {
      if (value) {
        callback();
      } else {
        callback(new Error("请上传广告图片"));
      }
    };
    return {
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      isDisabled: false,
      itemParams: {
        title: "",
        imgUrl: "",
        thumbnailUrl: "",
        sort: 1,
        status: 0,
        redirectUrl: "",
        adGroup: "home", // splash -- 首屏；home --- 主页
      },
      url: "",
      method: "",
      checkItemParams: {
        title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        imgUrl: [{ validator: checkIsImgUrl, message: "" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        status: [{ required: true, message: "请选择是否激活", trigger: "change" }],
        redirectUrl: [{ required: true, message: "请填写跳转地址", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/ads/home/query",
        method: "GET",
        params: {
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增数据
     */
    toCreate() {
      this.dialogVisible = true;
      this.dialogTitle = "新增广告";
      if (this.itemParams.adId) {
        delete this.itemParams.adId;
      }
      this.method = "POST";
      this.url = global.apiUrl + "/ads/save";
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 激活条目数据
     * @param id
     */
    activeItem(id) {
      this.$http({
        url: global.apiUrl + "/ads/active?id=" + id,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 禁用条目数据
     * @param id
     */
    forbidItem(id) {
      this.$http({
        url: global.apiUrl + "/ads/disable?id=" + id,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 修改条目数据
     * @param row
     */
    editItem(row) {
      this.dialogVisible = true;
      this.dialogTitle = "修改广告";
      if (row.redirectUrl.indexOf("http") > -1) {
        row.redirectUrl = row.redirectUrl.substring(row.redirectUrl.indexOf("//") + 2, row.redirectUrl.length);
      }
      Object.assign(this.itemParams, row);
      this.method = "PUT";
      this.url = global.apiUrl + "/ads/update";
    },
    /**
     * 保存条目数据
     * @param name
     */
    saveItem(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        const bodyParams = {};
        Object.assign(bodyParams, this.itemParams);
        if (bodyParams.redirectUrl.indexOf("http") === -1) {
          bodyParams.redirectUrl = "http://" + bodyParams.redirectUrl;
        }
        if (valid) {
          this.$http({
            url: this.url,
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.isDisabled = false;
                this.$message.success(res.body.info);
                this.loadTableData();
              } else {
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
          this.isDisabled = false;
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     *上传图片
     */
    doUpload() {
      const files = document.getElementById("uploadDom").files;
      const file = files[0];
      const params = new FormData();
      params.append("file", file);
      params.append("path", "upload/ad-img");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then(res => {
          this.itemParams.imgUrl = res.data.data;
        })
        .finally(() => {});
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/ads/delete?id=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .table-thumbnail {
    width: 100%;
    height: 50px;
    border: 1px solid #ebeef5;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 50px;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      cursor: pointer;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 9999;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
  }
}
</style>
